module.exports = __webpack_public_path__ + "static/media/1-AirHeatExchanger - DX cool - El heat.6218b634.png";